// @flow
/** @jsx jsx */

import { jsx, css } from '@emotion/core';
import * as React from 'react';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';

type Props = {
  onChange: string => mixed,
  onToggle?: boolean => mixed,
  selected?: string | number,
  options: Array<{
    value: any,
    text: string,
    id: string,
  }>,
  title?: string,
  id: string,
  disabled?: boolean,
  align?: 'left' | 'right',
  withError?: boolean,
};

const inlineErrorClass = css`
  border-color: red !important;
`;

export default class Dropdown extends React.Component<Props> {
  static defaultProps = {
    align: 'right',
  };

  render() {
    if (!Array.isArray(this.props.options)) {
      return null;
    }

    const selected = this.props.options.find(
      o => o.value === this.props.selected,
    );

    return (
      <div
        css={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {this.props.title && (
          <label
            css={{
              paddingRight: '10px',
              marginBottom: 0,
            }}
          >
            {this.props.title}
          </label>
        )}
        <ButtonToolbar
          css={[
            this.props.align === 'left' && {
              marginRight: 'auto',
            },
            this.props.align === 'right' && {
              marginLeft: 'auto',
            },
          ]}
        >
          <DropdownButton
            disabled={this.props.disabled}
            bsSize="xsmall"
            title={(selected && selected.text) || this.props.options[0].text}
            id={this.props.id}
            onSelect={this.props.onChange}
            css={[
              {
                minWidth: '70px',
              },
              this.props.withError && inlineErrorClass,
            ]}
            onToggle={this.props.onToggle}
          >
            {this.props.options.map(({ id, value, text }) => (
              <MenuItem
                key={id}
                active={value === this.props.selected}
                eventKey={value}
              >
                {text}
              </MenuItem>
            ))}
          </DropdownButton>
        </ButtonToolbar>
      </div>
    );
  }
}
